import { Link } from 'react-router-dom';
import './Playlist.css';
import './NoMatch.css';
import { useEffect } from 'react';

function NoMatch() {
    useEffect(() => {
        // Scroll to the top of the page when the component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='nomatch-container'>
            <h1 className="No-match-heading">Nothing to see here at present</h1>
            <p className="no-match" >We'll let you know when we have new content!</p>
            <Link to="/about" id='no-match-button'><button id='home-btn'>Back to Home</button></Link>

        </div>
    )

}

export default NoMatch;